<template>
  <v-app>
    <div style="width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: fit-content; vertical-align: top;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td></td>
          <td>&nbsp;</td>
          <td style="width: 35%; vertical-align: text-top; align-items: end;">
            <table v-if="ledger!=null" style="width: 100%">
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">Ledger</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ ledger.ledgercode}}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 11pt; font-weight: bold">End Date</span></td>
                <td style="text-align: right"><span style="font-size: 11pt;">{{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%; padding-bottom: 10px;">
        <tr>
          <td>
            <div align="center" style="padding: 0; line-height: 0;"><h3><b>Balance Sheet</b></h3></div>
            <p align="center" style="padding: 0; line-height: 0;">
              Period Ending:
              {{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
            </p>
          </td>
        </tr>
        <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%" cellpadding="0" cellspacing="0">
        <tbody v-if="data_asset.length!=0">
          <tr>
            <th :style="css['row-bottom-left']">ASSET</th>
            <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']">{{ ledger.secondaryCurrency }}</th>
            <th :style="css['row-bottom-right']">{{ ledger.primaryCurrency }}</th>
          </tr>
            <tr v-for="(trans) in data_asset"  v-bind:key="trans._id">
              <td :style="css['row-left']"> {{ trans.accountname }}</td>
              <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, false) }}</td>
              <td :style="css['row-right']">{{ TransAmount(trans, false) }}</td>
            </tr>
            <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
            <tr>
              <td :style="css['row-top-left']">TOTAL ASSET&nbsp;</td>
              <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_asset2 }}</td>
              <td :style="css['row-top-right']">{{ sum_asset }}</td>
            </tr>
        </tbody>
        <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
        <tbody v-if="data_liability_equity.length!=0">
          <tr>
            <th :style="css['row-bottom-left']">LIABILITY & EQUITY</th>
            <th v-if="ledger.isDualCurrency==true" :style="css['row-bottom-right']"></th>
            <th :style="css['row-bottom-right']"></th>
          </tr>
            <tr v-for="(trans) in data_liability_equity"  v-bind:key="trans._id">
              <td :style="css['row-left']"> {{ trans.accountname }}</td>
              <td v-if="ledger.isDualCurrency==true" :style="css['row-right']">{{ TransAmount2(trans, true) }}</td>
              <td :style="css['row-right']">{{ TransAmount(trans, true) }}</td>
            </tr>
            <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
            <tr>
              <td :style="css['row-top-left']">TOTAL LIABILITY & EQUITY&nbsp;</td>
              <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ sum_liability_equity2 }}</td>
              <td :style="css['row-top-right']">{{ sum_liability_equity }}</td>
            </tr>
        </tbody>
                
        <tr><td><div style="height: 20px;">&nbsp;</div></td></tr>
        <tbody>
            <tr>
              <td :style="css['row-top-left']">NET EQUITY&nbsp;</td>
              <td v-if="ledger.isDualCurrency==true" :style="css['row-top-right']">{{ net_equity2 }}</td>
              <td :style="css['row-top-right']">{{ net_equity }}</td>
            </tr>
        </tbody>
      </table>
      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../util/tools';

export default {
  name: 'PrintBill',
  props: {
    id: String
  },
  data() {
    return {
      logo: null,
      initvalue: {},
      ledger: {},
      data_company: {},
      transactions: [],
      decimal1: 0,
      decimal2: 0,
      css: {
        'row-top-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: solid;',
        'row-top-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: solid; font-weight: bold;',
        'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
        'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
        'row-left': 'text-align: left; padding: 2px;',
        'row-right': 'text-align: right; padding: 2px;',
      },
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getGLReportBSRequest', 'getCompanyDataRequest']),
    TransAmount(trans, isCredit){
    let result;
    if(isCredit==true) result = trans.creditAmount-trans.debitAmount;
    else result = trans.debitAmount-trans.creditAmount;
    result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
    
    return result;
  },
  TransAmount2(trans, isCredit){
    let result;
    if(isCredit==true) result = trans.creditAmount2-trans.debitAmount2;
    else result = trans.debitAmount2-trans.creditAmount2;
    result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
    
    return result;
  },
  },
  computed: {
    data_asset(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Asset');
      let filter = result.filter(trans=>(trans.debitAmount-trans.creditAmount)!=0 && (trans.debitAmount2-trans.creditAmount2)!=0);
      return filter;
    },
    data_liability_equity(){
      let results = this.transactions.filter(trans=>trans.accountclass=='Liability' || trans.accountclass=='Equity');
      return results;
    },
    data_equity(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Equity');
      return result;
    },
    sum_asset(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Asset');
      result = result.reduce((a, b) => a + (b.debitAmount-b.creditAmount), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return result;
    },
    sum_asset2(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Asset');
      result = result.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return result;
    },
    sum_liability_equity(){
      let result = this.transactions.filter(trans=>trans.accountclass=='Liability' || trans.accountclass=='Equity');
      result = result.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return result;
    },
    sum_liability_equity2(){
      let results = this.transactions.filter(trans=>trans.accountclass=='Liability' || trans.accountclass=='Equity');
      let result = results.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);

      result = result.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      console.log(result)
      return result;
    },
    net_equity(){
      let equity_sum = this.data_equity.reduce((a, b) => a + (b.creditAmount-b.debitAmount), 0);
      let result = equity_sum.toLocaleString("en-US", { minimumFractionDigits: this.decimal1, maximumFractionDigits: this.decimal1 });
      return result;
    },
    net_equity2(){
      let equity_sum = this.data_equity.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      let result = equity_sum.toLocaleString("en-US", { minimumFractionDigits: this.decimal2, maximumFractionDigits: this.decimal2 });
      return result;
    },
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getGLReportBSRequest(this.id);
      this.ledger = this.initvalue;
      this.transactions = Object.assign([], this.ledger.transactions);
      if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);
      this.decimal1 = this.data_company.options!=null ? this.data_company.options.PrimaryDecimalPlaces : 0;
      this.decimal2 = this.data_company.options!=null ? this.data_company.options.SecondaryDecimalPlaces : 0;
    }
  },
}

</script>

<style src="./Print.scss" lang="scss"/>
